export enum TabIds {
  MANAGE_LOGIN_INFO = 'manage-info',
  LOG_UPLOADER = 'log-uploader',
  CONNECTION_SETTINGS = 'connection-settings',
}
